const map = {
	"./_automaticRetryCollection": 83140,
	"./_automaticRetryCollection.js": 83140,
	"./_paginatedCollection": 94612,
	"./_paginatedCollection.js": 94612,
	"./arangoClusterStatisticsCollection": 23485,
	"./arangoClusterStatisticsCollection.js": 23485,
	"./arangoCollections": 74081,
	"./arangoCollections.js": 74081,
	"./arangoDatabase": 40399,
	"./arangoDatabase.js": 40399,
	"./arangoDocument": 30995,
	"./arangoDocument.js": 30995,
	"./arangoDocuments": 26710,
	"./arangoDocuments.js": 26710,
	"./arangoLogs": 86393,
	"./arangoLogs.js": 86393,
	"./arangoMetrics": 11585,
	"./arangoMetrics.js": 11585,
	"./arangoStatisticsCollection": 68317,
	"./arangoStatisticsCollection.js": 68317,
	"./arangoStatisticsDescriptionCollection": 2975,
	"./arangoStatisticsDescriptionCollection.js": 2975,
	"./arangoUsers": 33040,
	"./arangoUsers.js": 33040,
	"./clusterCoordinators": 23919,
	"./clusterCoordinators.js": 23919,
	"./clusterServers": 74022,
	"./clusterServers.js": 74022,
	"./coordinatorCollection": 77880,
	"./coordinatorCollection.js": 77880,
	"./foxxCollection": 67551,
	"./foxxCollection.js": 67551,
	"./foxxRepository": 78839,
	"./foxxRepository.js": 78839,
	"./graphCollection": 62722,
	"./graphCollection.js": 62722,
	"./notificationCollection": 29963,
	"./notificationCollection.js": 29963
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78348;